"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var PostType_1 = __importDefault(require("../PostType"));
var PostDate_1 = __importDefault(require("../components/card/PostDate"));
var PostPicture_1 = __importDefault(require("../components/card/PostPicture"));
var PostCategories_1 = __importDefault(require("../components/form/PostCategories"));
var PostPagination_1 = __importDefault(require("../components/form/PostPagination"));
var Post = /** @class */ (function (_super) {
    __extends(Post, _super);
    function Post(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidMount = function () {
            console.log("Mounting!!!");
            _this.getMaxPosts();
            _this.getPosts();
            _this.props.categories.forEach(function (category) {
                _this.getCategories(category.name, category.type);
            });
            if (_this.props.includeIndustry) {
                _this.getIndustries("post");
            }
        };
        _this.renderCards = function () {
            var loading = __spreadArray([], Array(_this.props.postsPerPage), true).map(function (x, i) {
                return react_1.default.createElement("div", { key: i, className: "col-md-4 col-sm-6" },
                    react_1.default.createElement("div", { className: "card card--post card__loading" },
                        react_1.default.createElement("div", { className: "gradient card__image-loading" }),
                        react_1.default.createElement("div", { className: "gradient card__title-loading" }),
                        react_1.default.createElement("div", { className: "gradient card__content-loading" })));
            });
            console.log("Are we loading? State: ", _this.state);
            if (_this.state.loading) {
                console.log("loading...");
                return (react_1.default.createElement("div", { className: "cards grid align-start" }, loading));
            }
            else {
                if (!_this.state.posts) {
                    return (react_1.default.createElement("div", { className: "cards grid align-start" }, loading));
                }
                var half = Math.floor(_this.props.postsPerPage / 2);
                var firstHalf = _this.state.posts.slice(0, half);
                var secondHalf = _this.state.posts.slice(half, _this.state.posts.length);
                var cards = _this.state.posts.map(function (post, i) {
                    return react_1.default.createElement("article", { key: i, className: "card card--post col-md-4 col-sm-6" },
                        react_1.default.createElement("a", { href: post.link },
                            react_1.default.createElement("div", { className: "card__media-wrapper" },
                                react_1.default.createElement(PostPicture_1.default, { image: post.image }, (post.primary_category && post.primary_category.name !== "Uncategorized") &&
                                    react_1.default.createElement("div", { className: "card__category" },
                                        react_1.default.createElement("p", null, post.primary_category.name)))),
                            react_1.default.createElement("h3", { className: "card__title h4" }, _this.convertHTMLEntity(post.title.rendered)),
                            react_1.default.createElement(PostDate_1.default, { date: post.date, format: 'do LLLL y' })));
                });
                return (react_1.default.createElement("div", { className: "cards grid align-start" }, cards));
            }
        };
        _this.renderCategories = function () {
            if (_this.state && _this.state.categories) {
                var categorySelects = void 0;
                if (_this.state.categories.length !== 0) {
                    console.log("Categories: ", _this.state.categories);
                    console.log("Selected Category: ", _this.state.selectedCategories);
                    categorySelects = _this.state.categories.map(function (category, i) {
                        return react_1.default.createElement(PostCategories_1.default, { postType: category.name, handler: _this.setCategory, options: category.ids, type: category.type, value: _this.props.selectedCategories !== null && _this.props.selectedCategories[0].name == category.name ? _this.props.selectedCategories[0].id : null });
                    });
                }
                else {
                    categorySelects = _this.props.categories.map(function (category, i) {
                        return react_1.default.createElement("div", { className: "post__".concat(category.type, "-loading") },
                            react_1.default.createElement("div", { className: "gradient" }));
                    });
                }
                return (react_1.default.createElement("div", { className: "post__categories" }, categorySelects));
            }
            else {
                return react_1.default.createElement("div", null, "No Categories :(");
            }
        };
        return _this;
    }
    Post.prototype.render = function () {
        return (react_1.default.createElement("section", { className: "card__wrapper" },
            react_1.default.createElement("div", { className: "card__categories-wrapper" },
                react_1.default.createElement("h1", null,
                    "Our ",
                    react_1.default.createElement("strong", null, "News")),
                this.renderCategories()),
            this.renderCards(),
            react_1.default.createElement("div", { className: "grid" },
                react_1.default.createElement(PostPagination_1.default, { handler: this.setPage, maxPages: this.state.pageCount, loading: this.state.loading }))));
    };
    return Post;
}(PostType_1.default));
exports.default = Post;
